import { defineMessages } from 'react-intl';

export default defineMessages({
  rovoSitePickerSpotlightTitle: {
    id: 'frontbucket.chatSidebar.rovoSitePickerSpotlightTitle',
    description: 'Title for the Rovo site picker spotlight',
    defaultMessage: 'Select your knowledge source',
  },
  rovoSitePickerSpotlightDescription: {
    id: 'frontbucket.chatSidebar.rovoSitePickerSpotlightDescription',
    description: 'Description for the Rovo site picker spotlight',
    defaultMessage:
      'Quickly switch between your Jira sites to provide Rovo with the proper context.',
  },
  rovoSitePickerSpotlightDoneButton: {
    id: 'frontbucket.chatSidebar.rovoSitePickerSpotlightDoneButton',
    description: 'Text for the done button in the Rovo site picker spotlight',
    defaultMessage: 'Done',
  },
});
